import React, { useState, useEffect } from "react"
import Style from './Style.module.css'
import Header from '../../../Components/AdminComponents/Header/Header'
import Sidebar from '../../../Components/AdminComponents/Sidebar/Sidebar'
import DataTable from '../../../Components/AdminComponents/DataTable/DataTable'
import adminInstance from "../../../instance/AdminInstance";

const MobileAdsLists = () => {
  const [mobileCarousels, setMobileCarousels] = useState([]);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      name: 'Image',
      cell: (row) => (
        <img 
          width={100} 
          height={80} 
          src={row.image.secure_url || row.image.url} 
          alt="carousel" 
          className={Style.SquareImage} 
        />
      ),
      width: '150px',
    },
    {
      name: 'Title',
      selector: (row) => row.title || 'N/A',
      sortable: true,
      width: '200px',
    },
    {
      name: 'Subtitle',
      selector: (row) => row.subtitle || 'N/A',
      sortable: true,
      width: '200px',
    },
    {
      name: 'Order',
      selector: (row) => row.order || 0,
      sortable: true,
      width: '100px',
    },
    {
      name: 'ID',
      selector: (row) => row._id,
      sortable: true,
      width: '200px',
    },
    {
      name: 'Options',
      cell: (row) => (
        <div className={Style.optionsContainer}>
          <button 
            className={Style.editButton} 
            onClick={() => handleToggle(row._id, row.active)}
          >
            {row.active ? 'Make Inactive' : 'Make Active'}
          </button>
          <button 
            className={Style.deleteButton} 
            onClick={() => handleDelete(row._id)}
          >
            Delete
          </button>
        </div>
      ),
      width: '250px',
    },
  ];

  const handleDelete = (carouselId) => {
    if (window.confirm('Are you sure you want to delete this mobile carousel?')) {
      try {
        adminInstance
          .delete(
            `/api/mobile_carousel/delete_mobile_carousel?carouselId=${carouselId}`
          )
          .then((response) => {
            console.log('Carousel deleted:', response.data);
            loadMobileCarousels();
          })
          .catch((err) => {
            console.error('Error deleting carousel:', err);
            alert('Error deleting carousel');
          });
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleToggle = (carouselId, currentStatus) => {
    try {
      adminInstance
        .put(
          `/api/mobile_carousel/toggle_mobile_carousel_active?carouselId=${carouselId}&status=${!currentStatus}`
        )
        .then((response) => {
          console.log('Carousel status updated:', response.data);
          loadMobileCarousels();
        })
        .catch((err) => {
          console.error('Error toggling status:', err);
          alert('Error updating carousel status');
        });
    } catch (error) {
      console.error(error);
    }
  };

  const loadMobileCarousels = () => {
    setLoading(true);
    try {
      adminInstance
        .get('/api/mobile_carousel/get_mobile_carousels')
        .then((response) => {
          setMobileCarousels([...response.data]);
          setLoading(false);
        })
        .catch((error) => {
          console.error('Error loading mobile carousels:', error);
          setLoading(false);
        });
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    loadMobileCarousels();
  }, []);

  return (
    <div className={Style.list}>
      <Sidebar />
      <div className={Style.listContainer}>
        <Header />
        <DataTable
          Row={mobileCarousels}
          Columns={columns}
          ActionColumn=""
          Title="Mobile Carousels"
          Links="Add New Mobile Carousel"
          Path="mob_ads"
        />
      </div>
    </div>
  );
};

export default MobileAdsLists;